import Image from 'next/image'
import React from 'react'
import Carousel from '../components/big/Carousel'
import CarouselMobile from '../components/big/CarouselMobile'
import SlickPartner from '../components/big/SlickPartner'
import Layout from '../components/Layout'
import Banners from '../models/bennerModels'
import Filters from '../models/filtersModel'
import Titles from '../models/titleModel'
import { convertDocToObj, getRelasisByJenis } from '../utils/serverSideFetch'

export default function about({titleData,dataOrmas,dataPartner,dataLayak,bannerDataPc,bannerDataMobile,filters}){

  
 
  return (
    
    <Layout titlePage={'about'} titleData={titleData} dataOrmas={dataOrmas}>
      <Carousel bannerDataPc={bannerDataPc}/>
      <CarouselMobile bannerDataMobile={bannerDataMobile}/>
      <section className='keAtas bg-white'>
        <div className="container bg-white text-black py-3">
          <div className="row justify-content-center">
            <h2 className='text-center my-3'>PT. MUAWANAH AL MA’SOEM</h2>
            <div className="col-md-5 rounded shadow p-3 mx-2 my-2">
              <center> <Image src={titleData.titleWeb} width="424" height="200"/></center>
              <p>{titleData.tentangKami}</p>
            </div>

            <div className="col-md-5 rounded shadow p-3 mx-2 my-2">
            <center> <Image src={'/blockquote.png'} width="306" height="200" /></center>
            <blockquote className="blockquote">
              <p>“{titleData.blockQuote}”
              </p>
              <figcaption className="blockquote-footer">
    <cite title="Source Title">{titleData.judulFooter}</cite>
  </figcaption>
            </blockquote>
            </div>


          </div>

          <section id="partner" className='bg-white overflow-hidden my-4 shadow rounded'>

          <SlickPartner dataPartner={dataPartner}/>

         

          </section>

          <section id='halal' className='bg-white mt-4 py-4 shadow rounded'>
            <div className="row">

              <div className="col-md-12">
                <h2 className='text-center'>Kelayakan PRODUK</h2>
                <p className='text-center'>
                  Produk Kami telah ter uji
                </p>
              </div>

              <div className="col-md-12">
                <center>
                  {dataLayak.map((legal) => (
                    <div className="mx-2 d-inline" key={legal._id}>
                    <Image src={legal.pictureRelasi}  width={110} height={110} />
                      </div>
                  ))}
                  
                  
                </center>
                
              </div>
            </div>
          </section>


          <div className="container mt-5 shadow rounded py-4">
	<div className="row justify-content-center">
		<div className="col-md-6">
			<h4 className='text-black'>Kebijakan <i> {titleData.judulFooter}</i> dalam Mengelolah PRODUK:</h4>
			<ul className="timeline">
				{filters.map(filter => (
				<li key={filter._id}>
					<h2 className='text-black'>{filter.name}</h2>
					<p className='text-black'>{filter.deskripsi}</p>
				</li>
				))}
				

			</ul>
		</div>
	</div>
</div>
        </div>
        </section>
    </Layout>
  )
}





export async function getStaticProps(context) {

 
  
 
  
  
  const dataOrmas = await getRelasisByJenis('ormas');
  const dataPartner = await getRelasisByJenis('partner');
  const dataLayak = await getRelasisByJenis('legal');
  const bannerDataPc = await Banners.find({halamanBanner : "about",tipeBanner : "pc"}).lean();
  const bannerDataPcCount = await Banners.find({halamanBanner : "about",tipeBanner : "pc"}).count();
  const bannerDataMobile = await Banners.find({halamanBanner : "about",tipeBanner : "mobile"}).lean();
  const bannerDataMobileCount = await Banners.find({halamanBanner : "about",tipeBanner : "mobile"}).count();
  const titleData = await Titles.findById('6301dbdb8e6ecc04f372e7fb').lean();
  const filters = await Filters.find({tipe: "about"}).lean();

  return {
      props: {
      dataOrmas : dataOrmas.map(o => convertDocToObj(o)),
      dataPartner : dataPartner.map(part => convertDocToObj(part)),
      dataLayak: dataLayak.map(leg => convertDocToObj(leg)),
      titleData: convertDocToObj(titleData),
      bannerDataPc: bannerDataPc.map(bp => convertDocToObj(bp)),count: bannerDataPcCount,
      bannerDataMobile: bannerDataMobile.map(bm => convertDocToObj(bm)),count: bannerDataMobileCount,
      filters : filters.map(f => convertDocToObj(f)),
    
    }, // will be passed to the page component as props
    revalidate: 30,
  }
}